import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "app/shared/services/auth.service";
import { Constants } from 'app/shared/config/constants';
import { BusinessUnitsService } from "app/shared/services/business-units.service";
import { forkJoin } from 'rxjs';
import { UserService } from "app/shared/services/user.service";
import { ClientService } from "app/shared/services/client.service";

@Injectable ( {
  providedIn: 'root',
} )
export class FedEntrypointService {

  readonly url = '/api/auth/app-token?locationIds=';

  constructor (
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService,
    private businessUnitsService: BusinessUnitsService,
    private userService: UserService,
    private clientService: ClientService
  ) {
  }

  async authenticateUser (): Promise<void> {
    const urlParams = new URLSearchParams ( location.search );
    const token = this.cookieService.get ( 'fed-token' );
    this.cookieService.delete ( 'fed-token', '/fed-auth' );
    try {
      await this.authService.logout ().toPromise ();
      const response = await this.http.post<{
        accessToken: string
      }> ( this.url + ( urlParams.get ( 'locationIds' ).split ( ',' )[ 2 ] || '' ), token ).toPromise ();

      if ( !response?.accessToken ) {
        return;
      }

      await this.authService.setAuthenticated ( true, response.accessToken );

      if ( urlParams.get ( 'locationIds' ) ) {
        let locationIds = urlParams.get ( 'locationIds' )
          .split ( ',' )
          .map ( id => id.trim () )
          .filter ( Boolean );

        if ( urlParams.get ( 'incidentReportingLocationId' ) ) {
          locationIds = [ urlParams.get ( 'incidentReportingLocationId' )! ];
        }
        // Fetch details for each locationId.
        if ( locationIds.length ) {
          const businessUnits = await forkJoin ( locationIds.map ( id => this.businessUnitsService.getBUDetails ( id ) ) )
            .toPromise ();
          if ( businessUnits?.length ) {
            const clientNumbers = businessUnits
              .map ( businessUnit => businessUnit?.gbClientNumber )
              .filter ( Boolean );
            this.userService.currentUser.clientAccessibility = [];
            const clients = await forkJoin ( clientNumbers.map ( clientNumber => this.clientService.searchClients ( clientNumber ) ) )
              .toPromise ();
            this.userService.userClients = clients.map ( client => client[ 0 ] );
            if ( urlParams.get ( 'incidentReportingLocationId' ) ) {
              const clientNumber = businessUnits.find ( bu => bu.id === urlParams.get ( 'incidentReportingLocationId' ) )?.gbClientNumber;
              if ( clientNumber ) {
                this.userService.enableClientChange ();
                this.userService.currentClientNumber = clientNumber;
                localStorage.setItem ( Constants.localStorageKeys.reporterClientSelected, '1' );
                this.userService.disableClientChange ();
              }
            }
          }
        }
      }

      if ( urlParams.has ( 'emailDirectMessageId' ) ) {
        localStorage.setItem ( Constants.localStorageKeys.fedEmailDirectMessageId, urlParams.get ( 'emailDirectMessageId' )! );
        urlParams.delete ( 'emailDirectMessageId' );
      }
      if ( urlParams.get ( 'locationIds' ) === '' ) {
        urlParams.delete ( 'locationIds' );
      }
      if ( urlParams.get ( 'redirect' ) ) {
        const redirectUrl = urlParams.get ( 'redirect' )!;
        urlParams.delete ( 'redirect' );
        await this.router.navigateByUrl ( redirectUrl );
        return;
      } else {
        await this.router.navigate ( [ 'home', 'new-incident' ], { queryParams: Object.fromEntries ( urlParams ) } );
      }
    } catch ( error ) {
      console.error ( 'Error during federation entrypoint authentication', error );
    }
  }
}
